// Hero copy definitions

const heroCopy = {
  titleWordOne: 'QUINTESSENCE',
  titleWordTwo: 'GAMES',
  tagline: 'Games for the Soul'
};

export default heroCopy;
